import { Component, OnInit } from '@angular/core';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { SettingsAnalyticsService } from 'src/app/data/repository/analytics-repository/settings-analytics.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  element: any;

  constructor(
    private settingService: SettingService,
    private settingAnalytics: SettingsAnalyticsService
  ) {}

  ngOnInit() {
    this.settingAnalytics.analyticSettingAboutUsVisited();
  }

  close() {
    this.settingService.goBack();
  }

  instagram() {
    window.location.href = 'instagram://user?username=bento.app';
  }

  email() {
    window.location.href =
      'mailto:Bento+ios@karafsapp.com?subject=پیشنهاد&body=';
  }

  call(e) {
    this.element = document.getElementById('call-button');
    this.clickAnimation();
    setTimeout(() => {
      window.location.href = 'tel:02191006901';
    }, 100);
  }

  clickAnimation() {
    this.element.style.width = 'calc( 100% - 56px )';
    this.element.style.right = '28px';
    this.element.style.height = '48px';
    this.element.style.top = '68px';
    setTimeout(() => {
      this.element.style.width = 'calc( 100% - 48px )';
      this.element.style.right = '24px';
      this.element.style.height = '56px';
      this.element.style.top = '64px';
    }, 100);
  }
}
